export default {
  'en-US': {
    fulfillmentMetricsTimeFilter: {
      Yesterday: 'Yesterday',
      Last7Days: 'Last 7 Days',
      Last30Days: 'Last 30 Days'
    }
  }
}
